/* import __COLOCATED_TEMPLATE__ from './standing-out.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { CxBenchmarkGroup } from './types';

interface StandingOutItem {
  label: string;
  difference: string;
  isPositive: boolean;
}

interface Signature {
  Args: {
    benchmarkGroup: CxBenchmarkGroup | undefined;
  };
}

export default class StandingOut extends Component<Signature> {
  @service declare intl: IntlService;

  // TODO: Compute from real benchmark data comparison
  get items(): StandingOutItem[] {
    return [
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-fin-answer-quality',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-fin-answer-quality',
        ),
        isPositive: true,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-informational-queries',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-informational-queries',
        ),
        isPositive: true,
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-negative-feedback',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-negative-feedback',
        ),
        isPositive: true,
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel::StandingOut': typeof StandingOut;
    'reporting/bespoke/fin-performance/cx-benchmark-panel/standing-out': typeof StandingOut;
  }
}
